import { Flex, Box, useBreakpointValue } from "@chakra-ui/react";
import { motion, useReducedMotion } from "framer-motion";
import { glassContentSx } from "@/theme/glassSx";

/**
 * Single shared glass canvas for every user page. Text inherits dark ink, so
 * every label must be wrapped in a glass surface to stay readable.
 */
const GlassBackground = ({ children, sx, ...props }) => {
  const bgAttachment = useBreakpointValue({ base: "scroll", md: "fixed" });
  const reduceMotion = useReducedMotion();

  return (
    <Flex
      as={motion.div}
      w="100%"
      minH={{ base: "100dvh", md: "100vh" }}
      p={{ base: 4, md: 6 }}
      pt={{ base: "max(4.5rem, env(safe-area-inset-top))", md: 6 }}
      pb={{ base: "max(1rem, env(safe-area-inset-bottom))", md: 6 }}
      initial={reduceMotion ? false : { opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      bgImage="url('/assets/bg.png')"
      bgSize="cover"
      bgPosition="center"
      bgAttachment={bgAttachment}
      position="relative"
      display="flex"
      direction="column"
      alignItems="center"
      justifyContent="start"
      zIndex={1}
      color="text.onGlass"
      _before={{
        content: '""',
        position: "absolute",
        inset: 0,
        backdropFilter: "blur(4px)",
        zIndex: 0,
      }}
      sx={{ ...glassContentSx, ...sx }}
      {...props}
    >
      <Box position="relative" zIndex={2} w="100%" maxW="100%">
        {children}
      </Box>
    </Flex>
  );
};

export default GlassBackground;
